
import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import SearchResultEntity from "../../../../domain/entities/search_result.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import MasterItemEntity from "../../../../domain/entities/master_item.entity";

const searchOpTypesApiImpl = async (_: { query: string | undefined, page: number, itemsPerPage: number }): Promise<Either<ErrorEntity, SearchResultEntity<MasterItemEntity>>> => {
    try {
        const { query, page, itemsPerPage }: { query: string | undefined, page: number, itemsPerPage: number } = _;
        let relativeUrl: string = `/operation?page_number=${page}&page_size=${itemsPerPage}&keyword=${query ?? ""}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.content.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
            }
        });
        return right({
            data: parsed,
            itemsPerPage: itemsPerPage,
            page: page,
            pages: response.total_pages,
            total: response.total_elements
        })
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default searchOpTypesApiImpl;
